import ApiResponse from "../ApiResponse";
import {ApiAuthRequestInterface, BuildAuthRequestFromAppState} from "../../authentication/BuildAuthRequestInterface";
import {ApiErrorReturn} from "../ApiError";
import ApiUrl, {PortalSource} from "../ApiUrl";

type ChangeUserPasswordResponse = ApiResponse<string>;

const buildFetchRequest = (body: string, apiAuth: ApiAuthRequestInterface): RequestInit => {
    return {
        method: 'post',
        headers: new Headers({
            'auth_token': apiAuth?.auth_token,
            'IsMarketPlace': apiAuth.IsMarketPlace,
            'Agent': apiAuth.Agent,
            'api_version' :apiAuth.api_version,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }),
        body,
    }}
export async function UpdateUserPassword(UserName: string, EmailSecret: string, Pin: string, NewPassword: string, Phone: string, errorHandling: ApiErrorReturn): Promise<ChangeUserPasswordResponse | null>{
    const apiAuth = BuildAuthRequestFromAppState(undefined);
    const Source = PortalSource();
    const body = JSON.stringify({
        Source,
        UserName,
        EmailSecret,
        Pin,
        Phone,
        NewPassword,
        OldPassword: '',

    });
    try {
        const response = await fetch(ApiUrl() + "FFOrderAccount/UpdateUserPassword", buildFetchRequest(body, apiAuth));
        return await response.json() as ChangeUserPasswordResponse;
    }catch(error: unknown){
        errorHandling(error);
        return null;
    }
}
